import type { ProjectDocumentationPathParams, UpdateProjectDocumentationBody } from '@si/types';
import { patch } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

type Params = ProjectDocumentationPathParams & UpdateProjectDocumentationBody;

export function useUpdateProjectDocumentation() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: (params: Params) =>
      patch({
        url: `/projects/${params.projectId}/documentation/${params.projectDocumentationId}`,
        body: { ...params },
      }),
    onSuccess: (_, variables) =>
      queryClient.invalidateQueries({
        queryKey: queryKeys.getProjectDocumentation(variables.projectId),
      }),
  });

  const updateProjectDocumentation = useCallback((params: Params) => mutate(params), [mutate]);

  return {
    updateProjectDocumentation,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
